import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { changePassword, validateToken } from "app/services/auth/resetPassword";

import { BASE_URL } from "static/constants";

export const resetPasswordApi = createApi({
  reducerPath: "resetPasswordApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query, mutation }) => ({
    verifyToken: query({
      queryFn: (token) => ({
        data: validateToken(token),
      }),
    }),
    resetPassword: mutation({
      queryFn: ({ token, newPassword, confirmPassword }) => ({
        data: changePassword(token, newPassword, confirmPassword),
      }),
    }),
  }),
});

export const { useVerifyTokenQuery, useResetPasswordMutation } =
  resetPasswordApi;
